const Calendar = ({ children, hasArrow = false, onPrev, onNext }) => {
    return (
        <div className="main-content__calendar">
            <div className="calendar-container">
                {children}
            </div>

            {hasArrow && (
                <>
                    <div className="main-content__calendar-side-menu-month-prev" onClick={onPrev}></div>
                    <div className="main-content__calendar-side-menu-month-next" onClick={onNext}></div>
                </>
            )}
        </div>
    );
};

export default Calendar;
